import { executeRequest, Request, Response } from '@jfs/network'
import { Config } from 'react-native-config'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (res: Response) => {
  if (res?.data?.responseStatus?.code === '000') {
    return {
      ...res?.data?.responseObj.agent?.agentStatus,
    }
  } else {
    const errorMsg = {
      errorCode: res?.data?.error?.code,
      errorMessage: res?.data?.error?.message,
    }
    throw errorMsg
  }
}

const getPayloadFromEntity = (mid: any, entity: any) => {
  const { name, contactDetails, businessName, type, addressDetails } = entity ?? {}
  let mobileNo: any = contactDetails[0]?.mobileNumber?.replace('+91', '')

  const { state, city, addressLine4, pincode, latitude, longitude, addressLine1, addressLine2, addressLine3 } =
    addressDetails ?? {}
  let address: any = addressLine1 ? `${addressLine1}` : ''
  address = addressLine2 ? addressLine1 + addressLine2 : addressLine1
  address = addressLine3 ? addressLine1 + addressLine3 : addressLine1
  const defaultAddress = {
    address: 'Reliance Corporate Park, Thane–Belapur Road, Ghansoli',
    state: 'Maharashtra',
    city: 'Navi Mumbai',
    country: 'India',
    pincode: '400701',
    latitude: '19.126285',
    longitude: '73.006938',
  }
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      orderType: 'BUY',
      description: 'This is for the buy case.',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
    agent: {
      name,
      aliasName: name,
      mobileNo,
      shopName: businessName,
      businessType: type ?? 'Agent',
      registeredAddress: address ?? defaultAddress.address,
      registeredState: state ?? defaultAddress.state,
      registeredCity: city ?? defaultAddress.city,
      registeredCountry: addressLine4 ?? defaultAddress.country,
      registeredPinCode: pincode ?? defaultAddress.pincode,
      latitude: latitude ?? defaultAddress.latitude,
      longitude: longitude ?? defaultAddress.longitude,
      merchantId: mid,
    },
  }
}

const returnBody = (mid, user: any) => {
  //const merchantObj: any = profileFromJSON(user, mid)
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      orderType: 'BUY',
      description: 'This is for the buy case.',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
    agent: {
      name: user?.name, //M
      aliasName: user?.name, //O
      mobileNo: user?.mobile, //M
      shopName: user?.shopName, //M
      businessType: user?.businessType, //M // Deafult – Agent
      registeredAddress: user?.address?.registeredAddress, //M
      registeredState: user?.address?.registeredState, //merchantObj?.contact?.addresses[0]?.state, //M
      registeredCity: user?.address?.registeredCity, //city, //M
      registeredCountry: user?.address?.registeredCountry ?? 'India', //M
      registeredPinCode: user?.address?.registeredPinCode, //merchantObj?.contact?.addresses[0]?.pincode, //M
      latitude: user?.address?.latitude, //M
      longitude: user?.address?.longitude, //M
      merchantId: mid, //M
    },
  }
}

export const onboardAgent = (tokens: any, userAccessToken: any, mid: any, user: any) => {
  const config = sitConfig(tokens)
  const reqPayload = returnBody(mid, user)
  // console.log('reqPayload', reqPayload)
  const request: Request<{}> = {
    apiPath: APIEndPoints.onboardAgent,
    method: 'POST',
    body: reqPayload,
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
